import Hero from "../components/Hero/Hero";
import Vision from "../components/Vision";
import Features from "../components/Features";
import { ExcitingFeatures } from "../components/ExcitingFeatures";
import ContactForm from "../components/ContactForm";
import { Testimonials } from "../components/Testimonials";
import { Pricing } from "../components/Pricing";
import CallToAction from "../components/CallToAction";
import ScrollToTopButton from "../components/ScrollToTopBottom";
import { useMediaQuery } from "react-responsive"; // Ensure this package is installed

const Home = () => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  return (
    <div>
      <Hero />
      <Vision />
      <Features />
      <ExcitingFeatures />
      <Testimonials />
      <Pricing />
      <ContactForm />
      <CallToAction />
      {isDesktop && <ScrollToTopButton />}
    </div>
  );
};

export default Home;
